import { linkToClassPage } from "../../links";

export function linkToEditClassAssignment(
  classId?: string,
  assignmentId: string = ":assignmentId"
) {
  return `${linkToClassPage(classId)}/edit-assignment/${assignmentId}`;
}
